import { isDate, registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

/**
 * Check if input property's Date value is later than the other property's Date value
 * @param property property name of the other Date value
 * @param validationOptions
 * @returns
 */
export function IsLaterThan(property: string, validationOptions?: ValidationOptions) {
    return function (object: Record<string, unknown>, propertyName: string) {
        registerDecorator({
            name: 'isLaterThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = (args.object as any)[relatedPropertyName];
                    if (!relatedValue) {
                        return true;
                    }
                    const relatedDate = new Date(relatedValue);
                    const dateValue = new Date(value);
                    return isDate(dateValue) && isDate(relatedDate) && dateValue > relatedDate;
                },
            },
        });
    };
}

/**
 * Check if input value is later than the given Date
 * @param date a concrete Date. Input value should be valid if later than this date
 * @param validationOptions
 * @returns
 */
export function IsLaterThanDate(date: Date, validationOptions?: ValidationOptions) {
    return function (object: Record<string, unknown>, propertyName: string) {
        registerDecorator({
            name: 'isLaterThanDate',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [date],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [laterThanDate] = args.constraints;
                    const dateValue = new Date(value);
                    return isDate(dateValue) && isDate(laterThanDate) && dateValue > laterThanDate;
                },
            },
        });
    };
}

/**
 * Check if input property's Date value is earlier than the other property's Date value
 * @param property property name of the other Date value
 * @param validationOptions
 * @returns
 */
export function IsEarlierThan(property: string, validationOptions?: ValidationOptions) {
    return function (object: Record<string, unknown>, propertyName: string) {
        registerDecorator({
            name: 'isEarlierThan',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = (args.object as any)[relatedPropertyName];
                    if (!relatedValue) {
                        return true;
                    }
                    const relatedDate = new Date(relatedValue);
                    const dateValue = new Date(value);
                    return isDate(dateValue) && isDate(relatedDate) && dateValue < relatedDate;
                },
            },
        });
    };
}

/**
 * Check if input value is earlier than the given Date
 * @param date a concrete Date. Input value should be valid if earlier than this date
 * @param validationOptions
 * @returns
 */
export function IsEarlierThanDate(date: Date, validationOptions?: ValidationOptions) {
    return function (object: Record<string, unknown>, propertyName: string) {
        registerDecorator({
            name: 'isEarlierThanDate',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [date],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [earlierThanDate] = args.constraints;
                    const dateValue = new Date(value);
                    return isDate(dateValue) && isDate(earlierThanDate) && dateValue < earlierThanDate;
                },
            },
        });
    };
}
